import { render, staticRenderFns } from "./support-block.vue?vue&type=template&id=1d6efb07&scoped=true"
import script from "./support-block.vue?vue&type=script&lang=js"
export * from "./support-block.vue?vue&type=script&lang=js"
import style0 from "./support-block.vue?vue&type=style&index=0&id=1d6efb07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6efb07",
  null
  
)

export default component.exports